import { __spreadArray } from "tslib";
/** Normalize to array a matcher input. */
export function matcherToArray(matcher) {
    if (Array.isArray(matcher)) {
        return __spreadArray([], matcher, true);
    }
    else if (matcher !== undefined) {
        return [matcher];
    }
    else {
        return [];
    }
}
//# sourceMappingURL=matcherToArray.js.map